import {
  Azure,
  Claude,
  Gemini,
  Openai,
} from "@arcadeai/design-system/components/ui/atoms/icons";
import { Sparkles } from "lucide-react";
import type { ComponentType } from "react";

type IconComponent = ComponentType<{ className?: string }>;

// Provider id (the segment before "/" in a router model id) → brand logo.
// Providers without a brand icon here fall back to a generic Sparkles glyph.
const PROVIDER_ICONS: Record<string, IconComponent> = {
  openai: Openai,
  anthropic: Claude,
  google: Gemini,
  gemini: Gemini,
  azure: Azure,
};

export function getProviderIcon(provider: string): IconComponent {
  return PROVIDER_ICONS[provider.toLowerCase()] ?? Sparkles;
}

// Display names for providers whose casing isn't a simple capitalization.
// Any provider not listed here gets the default `Capitalize(provider)`, which
// is already correct for most (Groq, Mistral, Cohere, Perplexity, ...).
const PROVIDER_LABELS: Record<string, string> = {
  openai: "OpenAI",
  anthropic: "Anthropic",
  google: "Google",
  gemini: "Gemini",
  xai: "xAI",
  deepseek: "DeepSeek",
  togetherai: "Together AI",
  openrouter: "OpenRouter",
  azure: "Azure",
};

export function getProviderLabel(provider: string): string {
  return (
    PROVIDER_LABELS[provider.toLowerCase()] ??
    provider.charAt(0).toUpperCase() + provider.slice(1)
  );
}
